var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"line"},[_c('img',{staticClass:"img",attrs:{"src":"https://hidataqrcode.oss-cn-hangzhou.aliyuncs.com/956753402996461568.png?Expires=1947495081&OSSAccessKeyId=LTAI5xyIqe4GhOvC&Signature=1tgjJuUBf1QnRFqcy4kg3LR8jEo%3D","alt":""}}),_c('span',[_vm._v("明之数据")])]),_c('div',[_c('span',[_vm._v("帮助千万企业实现数据驱动的商业经营")])])])
}]

export { render, staticRenderFns }